import { createApp } from "vue";
import App           from "./App.vue";
import router        from "./router";
import store         from "./store";
import JsonExcel     from "vue-json-excel3";
import VueTheMask    from "vue-the-mask"
import vuetify       from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "./registerServiceWorker";

loadFonts();

const isResizeObserverLoopError = (message = "") =>
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i.test(message);

window.addEventListener("error", (event) => {
  if (isResizeObserverLoopError(event.message)) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const message = event.reason?.message || String(event.reason || "");
  if (isResizeObserverLoopError(message)) {
    event.preventDefault();
  }
});

createApp(App).component("downloadExcel", JsonExcel).use(router).use(store).use(VueTheMask).use(vuetify).mount("#app");
